export default __webpack_public_path__ + "static/media/estate_donate.a417ebd5.svg";